var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShrink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 12V5a1 1 0 1 1 2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 1 0 2h-7a2 2 0 0 1-2-2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m29.707 3.707-9.5 9.5-1.414-1.414 9.5-9.5a1 1 0 1 1 1.414 1.414",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 20v7a1 1 0 1 1-2 0v-6a1 1 0 0 0-1-1H5a1 1 0 1 1 0-2h7a2 2 0 0 1 2 2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.293 29.707a1 1 0 0 1 0-1.414l9.5-9.5 1.414 1.414-9.5 9.5a1 1 0 0 1-1.414 0",
  clipRule: "evenodd"
})));
export default SvgShrink;